import { DonorStatus } from 'gql/types';

import { IDateBounds, PeriodType } from '../types';

interface IHistoryFilters {
  regionIds?: string[];
  officeIds?: string[];
  locationIds?: string[];
  activeDonorStatuses?: DonorStatus[];
}

export function buildHistoryInput(
  filters: IHistoryFilters,
  periodType: PeriodType,
  bars: number,
  anchorBounds: IDateBounds
) {
  return {
    periodType,
    bars,
    anchorRange: { start: anchorBounds.start, end: anchorBounds.end },
    regionIds: filters.regionIds?.length ? filters.regionIds : undefined,
    officeIds: filters.officeIds?.length ? filters.officeIds : undefined,
    locationIds: filters.locationIds?.length ? filters.locationIds : undefined,
    activeDonorStatuses: filters.activeDonorStatuses?.length
      ? filters.activeDonorStatuses
      : undefined,
  };
}
